import { render, staticRenderFns } from "./leveData.vue?vue&type=template&id=2abf0f0c&scoped=true"
import script from "./leveData.vue?vue&type=script&lang=js"
export * from "./leveData.vue?vue&type=script&lang=js"
import style0 from "./leveData.vue?vue&type=style&index=0&id=2abf0f0c&prod&scoped=true&lang=css"
import style1 from "./leveData.vue?vue&type=style&index=1&id=2abf0f0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf0f0c",
  null
  
)

export default component.exports